import { render, staticRenderFns } from "./FreightReview.vue?vue&type=template&id=6ac91633&scoped=true&"
import script from "./FreightReview.vue?vue&type=script&lang=js&"
export * from "./FreightReview.vue?vue&type=script&lang=js&"
import style0 from "./FreightReview.vue?vue&type=style&index=0&id=6ac91633&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac91633",
  null
  
)

export default component.exports